const handleClose = (e: Event) => {
  const button = e.target as HTMLButtonElement;
  const countdown = button.closest("[data-section-type='countdown']");
  countdown?.remove();
};

const closeCountdownButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('[data-countdown-close]');
closeCountdownButtons.forEach((button) => {
  if (button) {
    button.onclick = handleClose;
  }
})

const drawer: HTMLElement| null = document.querySelector('[data-cart-drawer]')
drawer?.addEventListener('click', function(event) {
  const button: HTMLButtonElement | null = (event.target as HTMLElement).closest('[data-countdown-close]');
  if (button) {
    handleClose(event);
  }
});
